import { time } from '@dr.pogodin/react-utils';

import { getLatestUserScores } from 'services/user-scores';

import {
  type RankingUserScoreKindT,
  type UserScoreT,
  useAsyncData,
  useGlobalState,
} from 'utils';

type RankingScoresT = Partial<Record<RankingUserScoreKindT, UserScoreT>>;

const RANKING_SCORE_KINDS: RankingUserScoreKindT[] = [
  'ARTIST_EXPERIENCE_COUNT',
  'ARTIST_IMPACT_COUNT',
  'MODALITY_EXPERIENCE_COUNT',
  'MODALITY_IMPACT_COUNT',
];

export type UseRankingUserScoresResT = {
  loading: boolean;
  scores: RankingScoresT;
};

export function useRankingUserScores(): UseRankingUserScoresResT {
  const [userId] = useGlobalState('user.id');

  if (!userId) throw Error('Unauthenticated');

  const e = useAsyncData(
    'userScoresRanking',
    async (): Promise<RankingScoresT> => getLatestUserScores(
      userId,
      RANKING_SCORE_KINDS,
    ),
    {
      deps: [userId],
      maxage: time.MIN_MS,
    },
  );

  return {
    loading: e.loading,
    scores: e.data ?? {},
  };
}
